import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './RisingVDP.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function RisingVDP(props) {
    const [data, setData] = useState([]);
    let optionInfoMarket = "Rising VDP";
    let optionTypeComp = "Daily Market Tracker";
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    // const [valuebtn, setValueBtn] = useState("G");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "RisingVDP";
            fetch(`${getUrl}/${groupValue}/-/Rise`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //  console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "RisingVDP";
            fetch(`${getUrl}/${groupValue}/-/Rise`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);




    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Rising Vdp",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Rising VDP</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='BetaStock-loser-sc'>
                            <div className='BetaStock-header'>
                                <h2><span>Rising VDP</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='BetaStock-table-main'>

                                <div className='BetaStock-right exchange'>
                                    <div className='BetaStock-inner-select'>
                                       
                                       {/* aria-label="bse nse" */}
                                        <select aria-label="bse nse" onChange={(event) => { setGroupValue(event.target.value); }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>

                                </div>
                                {/* <hr className="hrrisingvdp"></hr> */}

                                {/* tabIndex={0} */}
                                <div className='BetaStock-table table-responsive' tabIndex={0}>
                                    <table className='table'>
                                        <thead>

                                            <tr>
                                                <th id="ContentPlaceHolder1_outunderhead" className='bdrright padbottom30' rowspan="2">Company Name</th>
                                                {(data[0] != undefined) ? <>
                                                    <th className='text-right bdrright bdrbottom' colSpan="3"> {(data[0].date).split("T")[0]}</th>
                                                    <th className='text-right bdrright bdrbottom' colSpan="3">{(data[0].date2).split("T")[0]}</th>
                                                    <th className='text-right bdrright bdrbottom' colSpan="3">{(data[0].date3).split("T")[0]}</th></> : ''}
                                                <th id="ContentPlaceHolder1_outunder" className="text-right" rowspan="2">Fall in<br></br> Price(%)</th>
                                            </tr>

                                            <tr>

                                                <th className="text-center bdrright">Traded Qty</th>
                                                <th className="text-center bdrright">Del.Vol</th>
                                                <th className="text-center bdrright">Price(&#8377;)</th>
                                                <th className="text-center bdrright">Traded Qty</th>
                                                <th className="text-center bdrright">Del.Vol</th>
                                                <th className="text-center bdrright">Price(&#8377;)</th>
                                                <th className="text-center bdrright">Traded Qty</th>
                                                <th className="text-center bdrright">Del.Vol</th>
                                                <th className="text-center bdrright">Price(&#8377;)</th>
                                            </tr>





                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ Lname, QTY_TRADED, QTY_DELIVE, close, qty_traded2, qty_delive2, close2, qty_traded3, qty_delive3, close3, PriceRise, Co_Code }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={Lname + '-' + Co_Code}>{Lname} </h6></td>

                                                        <td className="text-right"> {QTY_TRADED}</td>
                                                        <td className="text-right"> {QTY_DELIVE}</td>
                                                        <td className="text-right"> {(close != null) ? close.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {qty_traded2}</td>
                                                        <td className="text-right"> {qty_delive2}</td>
                                                        <td className="text-right"> {(close2 != null) ? close2.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {qty_traded3}</td>
                                                        <td className="text-right"> {qty_delive3}</td>
                                                        <td className="text-right"> {(close3 != null) ? close3.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(PriceRise != null) ? PriceRise.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default RisingVDP;